module.exports = __webpack_public_path__ + "media/images/checkout/challenger/learn_more_2-00d9f41ffda9984fb3d470528210700e.png";